export default "__VITE_ASSET__Q8m1SOx7__"